/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ProcessingOptions } from './processingOptions';

/**
 * Parameters for a resource processing job
 */
export interface ResourceProcessJobParams {
  resourceId: string;
  processingOptions?: ProcessingOptions;
}
